import React from 'react';
import { styled } from '@compiled/react';
import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const ImportErrorMessage = () => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper data-testid="project-create-importer-upload-flow.common.ui.import-error-message.wrapper">
			<SectionMessage title={formatMessage(messages.errorHeader)} appearance="warning">
				{formatMessage(messages.errorDescription)}
			</SectionMessage>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	marginTop: token('space.100', '8px'),
	marginBottom: token('space.300', '24px'),
	width: '100%',
	maxWidth: '560px',
});
